import styled, { css } from "styled-components";

export const Container = styled.main`
  padding: 2rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    padding: 1.5rem;
  }
`;

export const SideContainer = styled.div`
  width: 100%;
`;

export const UsersFiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  margin: 2rem 0 2.75rem;

  div.filters_align {
    display: flex;
    justify-content: center;
    align-items: flex-end;

    gap: 1.5rem;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-size: ${(props) => props.theme.fontSize.XXXS};
    font-weight: ${(props) => props.theme.fontWeight.Semibold};
    font-family: ${(props) => props.theme.fontFamily.Sora};
    color: ${(props) => props.theme.colors.black};

    margin-bottom: 0.5rem;
  }
`;

export const Content = styled.section`
  margin-top: 1.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    margin-top: 1rem;
  }
`;

export const Title = styled.span`
  font-size: ${(props) => props.theme.fontSize.XXXS};
  font-weight: ${(props) => props.theme.fontWeight.Bold};
  color: ${(props) => props.theme.newColors["gray-900"]};
  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    font-size: 1rem;
  }
`;
export const StyledTableWrapper = styled.div`
  th:first-child,
  td:first-child {
    width: 95% !important;
  }
`;
